/* ===========================================================================
   CONFIGURAÇÃO COMPARTILHADA PORTAL ↔ PLAYER (v2.0)
   ---------------------------------------------------------------------------
   Fonte ÚNICA da allowlist de builds do EmulatorJS. O portal importa este
   módulo no bundle; o player.html carrega a versão IIFE gerada no build
   (dist/shared-config.js → window.EmuTabShared). Nunca há URL livre: o
   iframe recebe um IDENTIFICADOR de build e o player resolve o endpoint aqui.
   ======================================================================== */

const EMULATOR_BUILDS = {
  latest: 'https://www.naves.com.br/apps/emutab/emulatorjs/latest/data/',
  nightly: 'https://www.naves.com.br/apps/emutab/emulatorjs/nightly/data/',
};

const DEFAULT_EMULATOR_BUILD = 'nightly';

/** Resolve um identificador de build para { id, dataPath } ou null. */
function resolveEmulatorBuild(id) {
  const key = String(id || '').trim();
  if (!Object.prototype.hasOwnProperty.call(EMULATOR_BUILDS, key)) return null;
  return { id: key, dataPath: EMULATOR_BUILDS[key] };
}

function listEmulatorBuilds() {
  return Object.keys(EMULATOR_BUILDS);
}

// @generated-exports
export { DEFAULT_EMULATOR_BUILD, EMULATOR_BUILDS, listEmulatorBuilds, resolveEmulatorBuild };
// @generated-exports
